<template>
  <div class="delete-account">
    <div class="back-btn-header">
      <i
        @click="redirectToPreviousPage()"
        class="jfi-back-v2 back-icon mr20"
      ></i>
      <span class="mobile-heading fs-16">Delete User Account</span>

    </div>
    <div class="mobile-wrapper" v-if="getUserOTPStatus.status !== 'SUCCESS'">
      <span class="mobile-sub-txt fs-14">Deleting your Account will remove all the information.</span>
      <div class="div_input-mobile">
        <div class="mobile-widget">
          <span class="mob-default">{{ countryCode }}</span>
          <input
            type="tel"
            class="mob-default mob-input"
            :maxlength="max"
            v-model="mobileNum"
            @keydown="onKeyDownHandler($event)"
          />
          <span class="mobile-txt">Mobile Number</span>
        </div>
      </div>
      <div class="verify-btn-div">
        <button
          class="btn btn-w-100"
          :class="{
            disabled: mobileNum.length < 10,
          }"
          @click="getUserOTP()"
        >
          Send OTP
        </button>
      </div>
    </div>
    <div v-if="getUserOTPStatus.status == 'SUCCESS'">
      <div class="otp-info">
        <span class="otp-heading fs-16">Enter OTP for account deletion</span>
        <div class="otp-txt fs-14">
          OTP has been sent to
          <span>{{ countryCode }}-{{ this.mobileNum }}</span>
        </div>
      </div>
      <div class="otp-widget">
        <div class="div_input-otp">
          <div v-for="(n, index) in 6" :key="index">
            <input
              class="otp-num-input"
              type="number"
              name="searchQueryInputModal"
              v-model="otpVal[index]"
              @input="otpInputVal($event.target.value, index)"
              ref="input"
            />
          </div>
        </div>
        <span class="err-msg" v-if="getVerifyDeletedUser?.errors !== undefined">{{ getVerifyDeletedUser?.errors[0].displayMsg }}</span>
        <div class="resend-otp_row">
          <span
            class="resend-otp"
            :class="{
              disableColor: otpTimer > 0,
            }"
            @click="getUserOTP()"
            >RESEND OTP&nbsp;</span
          >
          <div v-if="otpTimer > 0">
            <span>in&nbsp;</span>
            <span class="timer-color">{{ otpTimer }}</span
            >s
          </div>
        </div>
      </div>
      <div class="verify-btn-div">
        <button
          class="btn btn-w-100"
          :class="{
            disabled: getUserOTPStatus.status !== 'SUCCESS',
          }"
          @click="deletUser()"
        >
          Verify and Delete
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsAction, keyMapsGetter } from "../helpers/storeKeys";
import { projectBasePathWithFolder } from "../config/apiEndpoints";
import { COUNTRY_CODE } from "../helpers/paymentConstants";
import PageNames from "../config/pageNames";

export default {
  name: "DeleteUserAccount",
  data() {
    return {
      otpTimer: 45,
      otpVal: "",
      otpIntervalFun: () => {},
      countryCode: COUNTRY_CODE,
      mobileNum: "",
      errMsg: "",
      showOtp: false,
      max: 10,
      hashValue: "",
    };
  },
  async mounted() {
    const url = window.location.href;
    Utility.setSessionStorageValue("nextgenhomepage", url);
    sessionStorage.currentNextgenFolder =
      Utility.getCurrentStoreFolder().replace(/^\/+|\/+$/g, "");

    this.$store.dispatch(keyMapsAction.LOAD_LOGIN_STATUS, {});
    this.hidePageLoader();

    if (!this.isLoggedIn) {
      Utility.sendToLoginScreen(window.location);
    }

    let userData = LocalStorageFunc.getUserData()?.userData;
    if(userData && typeof(userData) === "string"){
      userData = Utility.decryptData(userData);
    }
    
    this.mobileNum = this.isLoggedIn
      ? Number(userData?.mobile)
      : this.mobileNum;
  },
  updated() {
    if (this.getVerifyDeletedUser.status == "SUCCESS") {
      this.redirectToPreviousPage();
    }
  },
  methods: {
    hidePageLoader() {
      document.getElementById("pageLoader").style.display = "none";
    },
    redirectToPreviousPage() {
      let linkRewrite =  `/${PageNames.NEXTGEN_LINKREWRITE_HOME}/`;
      window.location.href =
        projectBasePathWithFolder +
        linkRewrite +
        LocalStorageFunc.storeId() +
        Utility.getUrlQueryString();
        this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API);
        localStorage.userInfo = {};
    },
    getUserOTP() {
      let userData = LocalStorageFunc.getUserData()?.userData;
      if(userData && typeof(userData) === "string"){
       userData = Utility.decryptData(userData);
      }
      
      const payload = {
        userId:
          Number(userData?.userId) || undefined,
        mobile: this.mobileNum,
        loggedInUser: this.isLoggedIn
      };
      this.$store.dispatch(keyMapsAction.DELETE_USER_ACCOUNT_DATA, payload);
      this.setOtpTimer();
    },
    deletUser() {
      const payload = {
        mobile: this.mobileNum,
        otp: this.otpVal,
        loggedInUser: this.isLoggedIn
      };
      this.$store.dispatch(keyMapsAction.VERIFY_DELETE_USER_ACCOUNT, payload);
    },
    otpInputVal(value, index) {
      const newInput = value;
      if (newInput === "") {
        this.otpVal = this.otpVal.replace(this.otpVal[index], "");
      } else {
        this.otpVal = this.otpVal + value;
      }

      if (newInput !== "" && index < this.$refs.input.length - 1) {
        this.$refs.input[index + 1].focus();
      } else if (newInput === "" && index !== 0) {
        this.$refs.input[index - 1].focus();
      } else {
        this.$refs.input[index].focus();
      }
    },
    mobileInputFunc(event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.target.value.length < 10) {
        this.mobileNum = event.target.value;
      } else {
        return;
      }
    },
    setOtpTimer() {
      clearInterval(this.otpIntervalFun);
      this.otpIntervalFun = setInterval(() => {
        if (this.otpTimer > 0) {
          this.otpTimer = this.otpTimer - 1;
        } else {
          clearInterval(this.otpIntervalFun);
        }
      }, 1000);
    },
    onKeyDownHandler(evt) {
      if (!new RegExp("[0-9]").test(evt.key) && evt.key.length === 1) {
        evt.preventDefault();
      }
    },
  },
  computed: {
    getUserOTPStatus() {
      return this.$store.getters[keyMapsGetter.GET_DELETE_USER_ACCOUNT_DATA];
    },
    getVerifyDeletedUser() {
      return this.$store.getters[keyMapsGetter.GET_VERIFY_DELETE_USER_ACCOUNT];
    },
    getFingerPrintInfo() {
      return this.$store.state.FingerPrint.hashKey;
    },
    isLoggedIn() {
      return this.$store.state.Auth.isLoggedIn;
    },
  },
};
</script>
